window.onscroll = function () {
	headerScroll();
	scrollPrev = window.scrollY;
};
headerScroll();
const header = document.querySelector(".header");
const temp = header.querySelector(".header__temp");
let scrollPrev = window.scrollY;
// var sticky = header.offsetTop;

function headerScroll() {
	
	if (window.scrollY > 50) {

		header?.classList.add("_scroll");
		if (scrollPrev > window.scrollY) {
			temp?.classList.remove("_open");
			header?.classList.add("_view");
		} else {
			header?.classList.remove("_view");
			document.querySelector('.header__temp')?.classList.remove('_open')
		}
	} else {
		header?.classList.remove("_scroll");
	}
}

if(document.querySelector('.header__temp-button')){
	if (document.querySelector('.front-top') && window.innerWidth>900) {
			document.querySelector('.header__temp').classList.add('_open')
	}
	document.querySelector('.header__temp-button').addEventListener('click', () => {	
		document.querySelector('.header__temp').classList.toggle('_open')
	})
	
   document.addEventListener('click', (event) => {
        if (!document.querySelector('.header__temp').contains(event.target)) {
            document.querySelector('.header__temp').classList.remove('_open')
        }
    });
}
setTimeout(() => {
	headerScroll()
}, 100)

